import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ_ITEMS, IMAGES } from "@/data/content";

export default function FAQ() {
  return (
    <div data-testid="page-faq">
      <PageHero
        overline="— FAQ"
        title="Frequently asked"
        accent="questions."
        body="Design, rendering, Cabinet Vision and production services — answered in plain language."
        image={IMAGES.bar}
        testid="faq-hero"
      />

      <section className="max-w-3xl mx-auto px-6 md:px-10 py-24" data-testid="faq-list">
        <Reveal>
          <Accordion type="single" collapsible className="w-full">
            {FAQ_ITEMS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-white/5"
              >
                <AccordionTrigger className="text-left font-serif text-xl text-[#EAEAEA] hover:text-[#B58B5D] hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#A3A3A3] text-[15px] leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </section>
    </div>
  );
}
